import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { clientMutation, clientQuery } from 'Core/data/GraphQLApi';
import { endpoints } from 'Core/defaultValues';

const INIT_STATE = {
    data: [],
    selectedDevices: [],
    result: null,
    openModal: false,
    loadingEdgeTensor: false,
    error: null,
    nextToken: null,
    conditions: null,
    accountParam: null,
    items: [],
    nextToken: null,
};

export const searchAiVideoReviewsByAccount = createAsyncThunk('tabEdgeTensor/searchAiVideoReviewsByAccount', async (args, { rejectWithValue }) => {
    try {
        const { conditions, sort, limit, offset, oldNextToken } = args;
        let response = await clientQuery(`
                query searchAiVideoReviews ($conditions: [AiVideoReviewSearchInput], $sort: [AiVideoReviewSortInput], $limit: Int, $offset: Int) {
                    result: searchAiVideoReviews (conditions: $conditions, sort: $sort, limit: $limit, offset: $offset) {
                        items {
                            unitId
                            deviceId
                            rowId
                            accountId
                            unitTime
                            eventResult
                            eventName
                            status
                            resultEventNames
                            deviceReading {
                                eventName
                                videoReview
                                deviceData
                            }
                            createdOn
                            updatedOn
                        }
                    }
                }`,
            {
                conditions,
                sort,
                limit,
                offset
            },
            endpoints.GRAPHQL_GENERAL
        );
        if (!response) {
            return { items: [], oldNextToken };
        }
        if (response?.errors) {
            return rejectWithValue(response.errors[0]?.message || 'Query failed');
        }
        const items = response?.result?.items || [];
        return { items, oldNextToken };
    } catch (error) {
        console.error('searchAiVideoReviewsByAccount error:', error);
        return rejectWithValue(error.message);
    }
}
);

export const getDevices = async (input = '', companyId) => {
    try {
        let QUERY = `
            query searchUnits ($conditions: [UnitSearchInput], $sort: [UnitSortInput], $limit: Int, $offset: Int) {
                result: searchUnits (conditions: $conditions, sort: $sort, limit: $limit, offset: $offset) {
                    items {
                        id
                        companyId
                        company {
                            id
                            name
                        }
                        label
                        esn
                        imei
                    }
                }
            }
        `;

        let conditions = []

        if (companyId) {
            conditions.push({
                fields: ["companyId"],
                terms: [companyId],
                exact: true
            })
        }

        if (input) {
            conditions.push({
                fields: ["esn", "label", "imei"],
                terms: [input],
                exact: false
            })
        }

        let data = await clientQuery(
            QUERY,
            {
                conditions: conditions,
                sort: [{ field: 'label', order: 'ASC' }],
                limit: 10,
                offset: 0
            },
            endpoints.GRAPHQL_GENERAL
        );

        return data?.result?.items || [];
    } catch (error) {
        console.error('Error fetching devices:', error);
        return [];
    }
}


const edgeTensorRedux = createSlice({
    name: 'accounts/tabEdgeTensor',
    initialState: INIT_STATE,
    reducers: {
        reset(state, action) {
            return action.payload ? { ...state, ...action.payload } : { ...INIT_STATE }
        },
        openModalEdgeTensor(state, action) {
            state.openModal = action.payload.open;
            state.accountParam = action.payload.account;
        }

    },
    extraReducers: (builder) => {
        builder
            .addCase(searchAiVideoReviewsByAccount.pending, (state) => {
                state.loadingEdgeTensor = true;
                state.error = null;
            })
            .addCase(searchAiVideoReviewsByAccount.fulfilled, (state, action) => {
                state.loadingEdgeTensor = false;
                state.items = action.payload.oldNextToken ? [...state.items, ...action.payload?.items] : action.payload?.items || [];
                state.nextToken = action.payload?.nextToken || null;
            })
            .addCase(searchAiVideoReviewsByAccount.rejected, (state, action) => {
                state.loadingEdgeTensor = false;
                state.error = action.payload;
            });
    },
});
const { actions, reducer } = edgeTensorRedux;

export const {
    reset,
    openModalEdgeTensor
} = actions;

export default reducer;